module.exports = __webpack_public_path__ + "img/0x.5ae60e52.svg";